import React from 'react'
import Sidebar from '../../components/Sidebar'
import DepositTable from './components/DepositTable'

const DepositReview = () => {
  return (
    <div className="flex overflow-hidden flex-col h-screen md:flex-row">
      {/* Sidebar handles its own desktop/mobile rendering */}
      <Sidebar />

      {/* Main content — scrolls independently */}
      <div className="overflow-y-auto flex-1 p-4 bg-white md:py-7">
        <h1 className="py-4 mb-0 text-xl font-bold md:text-2xl md:mb-6">Deposits Manual Review</h1>

        <div className="">
          <DepositTable />
        </div>
      </div>
    </div>
  )
}

export default DepositReview